import React, { Component } from "react";
import { useUser } from "@dreamchimney/user-context";
import { Helmet } from "react-helmet";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const AboutPage = () => {
  const { state: userState, dispatch } = useUser();
  return (
    <div className="page-about">
      <Helmet>
        <title>Sleevery | About | Dream Chimney</title>
      </Helmet>
      <Row>
        <Col xs={12}>
          <h1 className="page-header">About This Site</h1>
        </Col>
        <Col xs={12}>
          <p>
            This site is dedicated to album covers, or "sleeves", that are so out of this world that they deserve special attention. We have
            collected our favorites here and continue to add more as we find them. Follow us here and{" "}
            <a target="_blank" href="https://facebook.com/dreamchimney/posts">
              social
            </a>{" "}
            <a target="_blank" href="https://twitter.com/dreamchimney">
              media
            </a>{" "}
            for updates.
          </p>
          {!userState.loggedin && (
            <p>
              If you are a Chimney, please{" "}
              <a href="#" onClick={() => dispatch({ type: "signin_open" })}>
                login
              </a>{" "}
              to add a sleeve.
            </p>
          )}

          <p>If you have a sleeve that would fit this site please send to dreamchimney c/o gmail.</p>

          <p>
            ALSO if you have a better quality image/scan of a sleeve you see on this site, please also send it to dreamchimney c/o gmail.
          </p>

          <p>Thanks.</p>
        </Col>
      </Row>
    </div>
  );
};

export default AboutPage;
